import { Flower2, Megaphone, Leaf, Tag, Sprout, ShieldCheck } from "lucide-react";
import { BL_HERO_LOGO } from "./assets";

const TILES = [
  { key: "notices",  label: "Society Notice Board", sub: "Announcements & news",     icon: Megaphone },
  { key: "catalog",  label: "Black Leaf Catalogue", sub: "All dark-foliage varieties", icon: Flower2 },
  { key: "seeking",  label: "Seeking",              sub: "Help find a variety",       icon: Sprout },
  { key: "sale",     label: "For Sale",             sub: "Listings from members",     icon: Tag },
];

export function BLDashboard({ onNavigate, onCrossover, isAdmin }) {
  const tiles = isAdmin
    ? [...TILES, { key: "admins", label: "Admin console", sub: "Manage admins & password", icon: ShieldCheck, admin: true }]
    : TILES;
  return (
    <div className="bl-dash" data-testid="bl-dashboard">
      <div className="bl-dash-head">
        <img src={BL_HERO_LOGO} alt="Black Leaf Dahlia Society" className="bl-seal bl-seal-lg mx-auto" data-testid="bl-dash-seal"/>
        <p className="bl-kicker mt-4">Society dashboard</p>
        <h2 className="font-display text-3xl mt-2" style={{ color: "var(--bl-gold)", fontFamily: "Playfair Display, Georgia, serif", fontWeight: 800, letterSpacing: "0.02em" }}>
          Welcome, dark-bloom keeper.
        </h2>
        <p className="text-bl-soft italic mt-1">Choose where to wander.</p>
      </div>

      <div className="bl-tiles">
        {tiles.map(({ key, label, sub, icon: Icon, admin }) => (
          <button key={key} onClick={() => onNavigate(key)} className={`bl-tile ${admin ? "bl-tile-admin" : ""}`} data-testid={`bl-tile-${key}`}>
            <Icon size={28} strokeWidth={1.4} />
            <div className="bl-tile-label">{label}</div>
            <div className="bl-tile-sub">{sub}</div>
          </button>
        ))}
      </div>

      <div className="bl-cross-wrap">
        <button onClick={onCrossover} className="bl-cross-cta" data-testid="bl-cross-cta">
          <Leaf size={18}/>
          <span>
            <strong>Add Black Leaf dahlias to my garden</strong>
            <em>Open Bloom Keeper in our dark room</em>
          </span>
        </button>
      </div>
    </div>
  );
}
